import { partners } from '../../services/bff.api';

export const ADMIN_PARTNERS_RESOURCE = {
  key: 'ADMIN_PARTNERS_RESOURCE',
  table: {
    title: 'Partners',
    defaultSort: 'name',
    dataLocation: '_embedded.partners.result',
    disableRow: (data) => data?.name === 'Andere',
    searchParams: ['name'],
    fields: [
      { value: 'name', label: 'Naam', show: true, order: 0 },
      { value: 'postcode', label: 'Postcode', show: true, order: 0 },
      { value: 'city', label: 'Gemeente', show: true, order: 0 },
      { value: 'streetName', label: 'Straatnaam', show: true, order: 0 },
      { value: 'houseNumber', label: 'Huisnummer', show: true, order: 0 },
      { value: 'province', label: 'Provincie', show: true, order: 0 },
      { value: 'phone', label: 'Telefoon', show: true, order: 0 },
      { value: 'email', label: 'E-mail', show: true, order: 0 },
      { value: 'remarks', label: 'Algemene opmerkingen', show: false, order: 0 }
    ],
    dataTransform: (data) =>
      data?.map((i) => ({
        ...i,
        ...(i?.spoPartnerData ?? {})
      }))
  },
  api: {
    get: partners.search
  }
};
